import { actions as routerActions } from 'redux-router5';
import { NavigationOptions } from 'router5';

import { OrganizationType } from '@neptune/shared/core-organizations-domain';

import { getMyRunsEnabled } from 'common/featureFlag';
import { getContextOrganization, getCurrentRouteParams } from 'state/selectors-global';
import { AppState, NThunkDispatch } from 'state/types';

import { convertRouteName } from './helpers';
import { isEnterpriseContext } from './selectors';

/**
 * @deprecated use @neptune/shared/routing-business-logic instead.
 */
export function navigateTo(
  routeName: string,
  routeParams?: { [key: string]: any },
  options: NavigationOptions & {
    forceContext?: /* ORGANIZATION_TYPES */ string;
    extendParams?: boolean;
  } = {},
) {
  return (
    dispatch: NThunkDispatch<ReturnType<typeof routerActions.navigateTo>>,
    getState: () => AppState,
  ) => {
    const { forceContext, extendParams, ...routeOptions } = options;

    const isEnterprise = forceContext
      ? forceContext === OrganizationType.team
      : isEnterpriseContext(getState());

    const params = extendParams
      ? {
          ...getCurrentRouteParams(getState()),
          ...routeParams,
        }
      : routeParams;

    const convertedRouteName = convertRouteName(routeName, isEnterprise);
    dispatch(routerActions.navigateTo(convertedRouteName, params, routeOptions));
  };
}

export function navigateToHome() {
  return (dispatch: NThunkDispatch<ReturnType<typeof routerActions.navigateTo>>) => {
    dispatch(routerActions.navigateTo('home', undefined, { replace: true }));
  };
}

export function redirectToWorkspaceDashboard() {
  return (
    dispatch: NThunkDispatch<ReturnType<typeof routerActions.navigateTo>>,
    getState: () => AppState,
  ) => {
    const organization = getContextOrganization(getState());

    if (!organization) {
      dispatch(routerActions.navigateTo('join-workspace', {}, { replace: true }));
      return;
    }

    if (getMyRunsEnabled()) {
      dispatch(routerActions.navigateTo('user-my-runs', {}, { replace: true }));
      return;
    }

    const isEnterprise = organization.organizationType !== OrganizationType.individual;

    const routeName = convertRouteName('organization.projects', isEnterprise);

    dispatch(
      routerActions.navigateTo(
        routeName,
        { organizationName: organization.name },
        { replace: true },
      ),
    );
  };
}
